import React from 'react';
import './PC.css';
import Cuesta from '../../img/PC/Cuesta.png'
import Gupta from '../../img/PC/Gupta.png'
import Jorquera from '../../img/PC/Jorquera.png'
import Kamaruzzaman from '../../img/PC/Kamaruzzaman.png'
import Kocot from '../../img/PC/Kocot.png'
import Lopes from '../../img/PC/Lopes.png'
import Viswanathan from '../../img/PC/Viswanathan.png'
import Peramune from '../../img/PC/Peramune.png'
import Madian from '../../img/PC/Madian.png'
import Loza from '../../img/PC/Loza.png'
import Cardona from '../../img/PC/Cardona.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Kamaruzzaman,
          name: 'Md Kamaruzzaman',
          position: 'Lead Solution Architect',
          ln: 'https://www.linkedin.com/in/md-kamaruzzaman-54280b10/',
        },
        {
          photo: Lopes,
          name: 'Paulo Lopes',
          position: 'Principal Software Engineer',
          tw: 'https://twitter.com/pml0p35',
          ln: 'https://www.linkedin.com/in/pmlopes/',
        },
        {
          photo: Kocot,
          name: 'Daniel Kocot',
          position: 'API Expert / Senior Solutions Architect',
          ln: 'https://www.linkedin.com/in/danielkocot/',
        },
        {
          photo: Gupta,
          name: 'Rahul Gupta',
          position: 'Software Architect/Technical Leader',
          ln: 'https://www.linkedin.com/in/rahul-g-08aa985/',
        },
        {
          photo: Cuesta,
          name: 'Jesus Cuesta',
          position: 'Senior Specialist Lead',
          ln: 'https://www.linkedin.com/in/jesuscuesta',
        },
      ],
      pcHide: [
        {
          photo: Jorquera,
          name: 'Rodrigo Jorquera',
          position: 'Senior Cloud Solutions Architect',
          ln: 'https://www.linkedin.com/in/rodrigojorquera/',
        },
        {
          photo: Viswanathan,
          name: 'Ompragash Viswanathan',
          position: 'Senior Software Engineer',
          tw: 'https://twitter.com/ompragash_v',
          ln: 'https://www.linkedin.com/in/ompragash/',
          github: 'https://github.com/Ompragash',
          yb: 'https://youtube.com/c/opensourceops',
        },
        {
          photo: Peramune,
          name: 'Lahiru Chamil Peramune',
          position: 'Cloud Platform Engineer',
          ln: 'https://www.linkedin.com/in/lahiru-peramune/',
        },
        {
          photo: Madian,
          name: 'Rami Madian',
          position: 'Cloud Architect',
          ln: 'https://www.linkedin.com/in/rami-a/',
        },
        {
          photo: Loza,
          name: 'Hugo Loza',
          position: 'Engineering Director',
          ln: 'http://www.linkedin.com/in/hugoloza',
        },
        {
          photo: Cardona,
          name: 'Rafael Cardona',
          position: 'Cloud Solution Architect',
          ln: 'https://www.linkedin.com/in/rcardona-cloud/',
        },
      ],
      hide: true,
    }
    this.togglePC = this.togglePC.bind(this);
  }

  togglePC() {
    this.setState({hide: !this.state.hide});
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel='noreferrer' href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel='noreferrer' href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel='noreferrer' href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel='noreferrer' href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel='noreferrer' href={item.website}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="pc" id='pc'>
              <div className='container team_wrap'>
                  <h3>Program committee</h3>
                  <div className="pc_block">
                    {this.state.pc.map((item, i) => this.renderPC(item, i))}
                    {!this.state.hide && this.state.pcHide.map((item, i) => this.renderPC(item, i))}
                  </div>
                  <button className='video_btn' onClick={this.togglePC}>{this.state.hide ? 'Show more' : 'Hide'}</button>
              </div>
          </div>
      )
  }
}